<template>
  <section class="app-carousel-media">
    <div v-if="object.media && object.media.length">
      <div class="relative">
        <template v-if="object.media.length > 1 && carouselState != null">
          <button class="carousel-control-button carousel-control-nav-button slider__button left" @click="previous">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
              <path d="M16.37,6.57,10,12.76,3.63,6.57" fill="none" stroke-miterlimit="10" stroke-width="2"></path>
            </svg>
          </button>
          <button class="carousel-control-button carousel-control-nav-button slider__button right" @click="next">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="svg-icon">
              <path d="M16.37,6.57,10,12.76,3.63,6.57" fill="none" stroke-miterlimit="10" stroke-width="2"></path>
            </svg>
          </button>
        </template>
        <UiCarousel
          ref="uiCarouselRef"
          :options="{ autoPlay: true, prevNextButtons: false, pageDots: true, adaptiveHeight: false }"
          class="media-gallery"
          @update="onUpdate">
          <div
            v-for="item in object.media"
            :key="item.id"
            class="flex-shrink-0 px-6 media-item"
          >
            <video
              v-if="item.type.startsWith('video')"
              :src="item.url"
              controls
            ></video>
            <AppImage
              v-else
              :src="item.url_large || item.url_medium || item.url"
              :alt="object.title"
              :ratio="object.type === 'show' ? '1:1' : '3:2'"
            />
          </div>
        </UiCarousel>
        <AppButtonLike
          v-if="carouselState != null"
          class="absolute right-5 top-5"
          size="md"
          :active="!!object.favourited"
          @click="
              async (event) => {
                event.preventDefault()

                await favourites.toggleFavourite({
                  id: object.id,
                  type: type,
                  favouriteId: object.favourited,
                })

                if (auth.user?.id) {
                  object.favourited = object.favourited ? null : object.id;
                }
              }
              "
        />
      </div>
    </div>
    <AppImage v-else />
  </section>
</template>

<script setup lang="ts">
import UiCarousel from '@boats/ui/components/UiCarousel.vue'

const favourites = useFavouritesStore()

type Props = {
  type: String
  object: Object
}

const props = defineProps<Props>()

const uiCarouselRef = ref()
const carouselState = ref<any>(null)
const auth = useAuthStore()

const previous = () => uiCarouselRef.value.previous()
const next = () => uiCarouselRef.value.next()
const onUpdate = (state: any) => (carouselState.value = state)
</script>

<style lang="scss">
@use 'sass:math';
@import '@boats/ui/styles/config';

$carousel-gutter: 0.375rem;

/* Before ssr made */
.media-gallery:not(.flickity-enabled) .media-item:not(:first-child) {
  transform: translateX(100%);
  position: absolute;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.app-carousel-media {
  margin-bottom: 1em;

  .ui-carousel {
    margin-left: -$carousel-gutter;
    margin-right: -$carousel-gutter;

    .flickity-cell {
      width: 100%;
      padding-left: $carousel-gutter;
      padding-right: $carousel-gutter;
    }

    .flickity-page-dots {
      bottom: 10px;
    }
  }
}

.carousel-control {
  &-button {
    outline: none;
    background-color: transparent;
    position: absolute;
    z-index: 2;
    cursor: pointer;
  }

  &-nav-button {
    top: 50%;
    border: 1px solid $white;

    &.left {
      left: 12px;
      bottom: 50%;
      transform: translateY(-50%) rotate(90deg);
    }

    &.right {
      right: 12px;
      transform: translateY(-50%) rotate(270deg)
    }

    &:hover {
      @include smooth-transition();
      background-color: $black;
      color: $white;
      border: 1px solid $black;
    }
  }
}

.slider__button {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    stroke: $white;
    width: 20px;
    height: 20px;
  }
  cursor: pointer;
  outline: none;
  background-color: transparent;
  border-radius: 50%;
  border: 1px solid $white;

  &.left {
    transform: rotate(90deg);
  }

  &.right {
    transform: rotate(270deg);
  }

  &.disabled {
    border: 1px solid $gray-300;
  }
}

</style>
